@if (basicWidgetComponent$ | async; as basicWidgetComponent) {
    <ng-container
        [ngComponentOutlet]="basicWidgetComponent"
        [ngComponentOutletInputs]="{ config: basicWidgetComponentConfig, context: context }"
    />
}
